import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import platformApi, { PLATFORM_TOKEN_KEY, platformErrorMessage } from '../../services/platformApi'
import './platform.css'

const STATUS_LABEL = {
  pending: 'Pendente',
  provisioning: 'Criando tabelas',
  active: 'Ativa',
  failed: 'Falhou',
  suspended: 'Suspensa',
}

const SURFACE_LABEL = {
  erp_and_institutional: 'ERP e vitrine',
  erp_and_storefront: 'ERP e loja',
}

function OrganizationsPage() {
  const navigate = useNavigate()
  const [organizations, setOrganizations] = useState([])
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let active = true
    platformApi
      .get('/api/platform/organizations')
      .then(({ data }) => {
        if (active) setOrganizations(data.organizations || [])
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          localStorage.removeItem(PLATFORM_TOKEN_KEY)
          navigate('/plataforma/login', { replace: true })
          return
        }
        if (active) setError(platformErrorMessage(err, 'Não foi possível listar as organizações'))
      })
      .finally(() => {
        if (active) setLoading(false)
      })
    return () => {
      active = false
    }
  }, [navigate])

  const logout = () => {
    localStorage.removeItem(PLATFORM_TOKEN_KEY)
    navigate('/plataforma/login', { replace: true })
  }

  return (
    <div className="platform-page">
      <header className="platform-topbar">
        <div>
          <h1>Organizações</h1>
          <p>Cadastro pendente até a autorização criar as tabelas.</p>
        </div>
        <div className="platform-actions">
          <Link className="platform-button" to="/plataforma/nova">Nova organização</Link>
          <button className="platform-button-secondary" type="button" onClick={logout}>Sair</button>
        </div>
      </header>
      <main className="platform-body">
        {error ? <p className="platform-error">{error}</p> : null}
        {loading ? <p className="platform-note">Carregando…</p> : null}
        {!loading && organizations.length === 0 ? (
          <p className="platform-note">Nenhuma organização cadastrada.</p>
        ) : null}
        <div className="platform-list">
          {organizations.map((organization) => (
            <Link
              key={organization.id}
              className="platform-card platform-org"
              to={`/plataforma/${organization.id}`}
            >
              <div>
                <h2>{organization.trade_name || organization.legal_name}</h2>
                <p>
                  {organization.slug} · {SURFACE_LABEL[organization.surface] || organization.surface}
                </p>
              </div>
              <span className={`platform-status platform-status-${organization.status}`}>
                {STATUS_LABEL[organization.status] || organization.status}
              </span>
            </Link>
          ))}
        </div>
      </main>
    </div>
  )
}

export default OrganizationsPage
